module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a visit to the oberst")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride had spoken to many former Wehrmacht officers, all of them reduced to scribbled private shorthand in his notebooks or had become disembodied voices on cassette tapes. Yet Menschler was different, if only in that he was more intensely reminiscent of a former self than the others. He was different, and not merely because he was blind; the lines of visible scar tissue were like pointing accusations, lines of perspective drawn to the dead eyes. Menschler was complete in another way, in the entirety with which he chose to inhabit the past, to walk corridors long disused—even the final corridors of the Führerbunker. His almost total recall promised well for McBride, chilling and fascinating him as they sat in the blind-man’s living room in the wooden house on Norderney, in the East Frisians.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride was seated facing the window, perhaps two or three yards from the desk where Menschler sat, his back to the window and its square of grey sky and choppy sea nibbling at the stretch of beach below the house. The house had seemed an outpost as he had approached it on foot along the beach road. It was a summer house—Menschler lived there all year, and had done since the early 1950s, when his prison sentence was commuted by a West German court. It seemed to McBride that he had chosen this flat, windy splinter of the Bundesrepublik out of a total disapproval of post-war Germany. Hermitage, or place of exile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The furniture in this main room was old, heavy, dark. Polished by his caresses rather than by creams or waxes. Even the way in which Menschler gripped the arms of his chair at that moment suggested both possession and defiance. And he had the trick of looking directly at his visitor’s face as he listened or spoke, and not in a vague direction over one of McBride’s shoulders. His blind eyes seemed disconcertingly aware in the room and its fading early evening light.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Emerald Necklace. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride’s thoughts pushed impatiently, nudging him into speech. For the moment, he resisted the temptation to broach the real subject of his visit, while Menschler spoke of the last days, when his Germany had gone up in flames with two bodies in the grounds of the Reichschancellery. McBride wished, half-attentively, that he had obtained Menschler’s first-hand impressions for his previous book.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The Führer surrounded himself with SS trash in those last days—’ They were speaking in German, a language in which the American, McBride, was fluent. The contempt, the hatred of the army’s displacement by the SS was undimmed by the slow blind passage of forty years. ‘Even while their glorious leader, with his bowel trouble and his belief in sorcery, was doing away with himself like a rat taking poison—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Four days before, in the Bundesarchiv in Koblenz, McBride had found the most tangible reference to Emerald Necklace, in a private letter written by Menschler to his cousin, a Junker Generalleutnant on the Oberkommando der Wehrmacht staff in Berlin, whose papers had been bequeathed to the Koblenz archives on his death in the early ‘6os. And unlike the memories of other men to whom he had spoken, or the official records, there had been no OKW censorship or editing. A private letter which referred to a top-secret army matter had survived intact, been waiting for him at the end of a long and fruitless search for a proposed operation that had never received the usual ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fall—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Case—designation used by OKW for France, Russia, Britain, Poland, Crete, Africa.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His book had begun as a sober treatise designed to enhance his academic status and reputation. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Politics of Invasion: the Führer and his Wehrmacht, 1939")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("–")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("42. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sober enough for any narrow-minded, conservative faculty board. McBride shrugged the image away. That was all before ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("eight weeks on the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("New York Times ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("list in hard-cover, half-a-million copies in print in soft cover—and he’d returned to his treatise, seeking to inject it with popular appeal, dynamism, something ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("new. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And Emerald Necklace, a name in a dusty Pentagon file of agents’ reports from 1940, a name overheard or dimly remembered by a handful of Germans still living—and a reference in a letter dated October 1940 from Oberst Karl Menschler, a name he already knew dimly from his research on ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fall Gelb, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the invasion of France, and from the planning group of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seelöwe, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Hitler’s proposed and abandoned invasion of Britain.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride knew the war held few beneficial secrets to ambitious historians, especially those who had chosen the marketplace to make their mark rather than the groves of academe that had seemed to slight and undervalue him for so long. All the bodies had been dug up—Babi Yar, the Cossacks handed over to Stalin’s mercy, Katyn, the Final Solution, the atom bomb, had all received their popular historical exploitation. But—Emerald Necklace. If it was real, then it was new. No one had done it, no one even ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("knew ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of it—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His hand had quivered, his breath seeming to be held throughout, as he read and reread Menschler’s letter to his cousin.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now, Menschler seemed to subside like a kettle gone off the boil. He sat stiff-backed in the chair, staring at McBride’s features as if he could read their expression, or")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as if demanding that he make some comment on what he had heard. McBride coughed, watched a seagull lifted then plucked from its course by the wind off the sea, and picked out the painted dark strip of the German mainland subsiding into shadow five miles away on the horizon.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Herr Menschler, thank you. Perhaps I could take you—unless you’re tired—back to France in 1940?’ McBride wondered whether his voice betrayed his excitement, his anxiety. Menschler’s face was partly in shadow, but he was certain that the head moved slightly, a small flinch at the tone or subject.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, Herr Professor?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride paused on the edge of the moment. His journey in a rented blue Audi from Koblenz up the Rhine into flatter and flatter northern Germany the previous day had effectively depressed his tension and anticipation. The short ferry journey, leaving the Audi on the jetty at Norddeich, in the company of a few late holidaymakers from Hamburg and the Ruhr crossing to Norderney for an off-season, cheap-rate ten days, had increased his sense of possible foolishness, of chasing after a whim and looking very, very dumb. The flat, uninteresting Frisian island held no promise as the ferry neared the old village and its tiny jetty.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yet Menschler was real, and alive, and he had written the letters in the Bundesarchiv. He could be a few minutes away from the new heart of his book, and its probable status as a bestseller—including the six-figure, maybe seven­figure soft-cover advance—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("On the edge of the moment, he indulged the comforting, comfortable prognostications. Print-runs, contracts, sales figures. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A new, unknown invasion—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a “rewriting of history? A strange, bubbling excitement in him was compounded by the clear memory of his telephone conversation with Menschler two days earlier; the Oberst had been frostily polite, but reluctant, as if for him, too, the proposed meeting was heavy with significance.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You were on the support planning staff for ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fall Gelb, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and later for ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seelöwe?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler nodded, but after a pause. Had the facts come back only slowly, or did he anticipate what might follow the slightest admission? ‘What happened, Herr Oberst, after ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seelöwe ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was postponed indefinitely on October 12th, 1940?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What do you mean, Herr Professor, what happened? We did not invade England, that is what happened.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I mentioned a letter you had written—one of three or four—to your second cousin, Generalleutnant Alfred von Kass on—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The 23rd of October.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes. Could I ask you about that?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The silence seemed to continue for a long time, and the room’s weight of furniture and memory pressed upon McBride with a tangible presence. He felt enclosed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why? It was a private letter. Much better to ask concerning ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Fall Gelb, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seelöwe—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I can give you many insights, my memory is excellent.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, Herr Menschler. I appreciate that. But I’m interested in ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Emerald Necklace you referred to in the letter. It wasn’t a family heirloom.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler’s face remained unmoved at the remark. ‘Perhaps not—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You said, and I quote—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I recollect exactly what I wrote.’ The voice placed McBride, made him a reporter, an amanuensis and nothing more. It cancelled the inbred German esteem for his academic title. Now he was little more than a busybody from the gutter press.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why are you reluctant, sir? It’s forty years ago.’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Reluctant?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘There is something—but you won’t talk about it.’ McBride suppressed a rising irritation sharp as bile.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This is the first time you have come across this, this—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("halskette?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride was certain of a fervent hope in the question.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, sir, it is not. I have maybe another dozen references to it, always by the same name, verbal and written. In files in America, and here in Germany. Maybe in England, too, though I haven’t checked it out. But at second, third, fourth hand, I admit. You were there—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler shifted in his chair. A parody of relaxation, yet McBride sensed the German had removed himself further from his guest, and from emotions that guest might initially have aroused. A thin cut of a smile on his face, giving the accusing lines of scar tissue a more recent vivacity on his white face.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ah, I am to be impressed by such notoriety as you imply in your tone, mm?’ The thin smile broke the planes of his face again. ‘You suggest that I—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("tell all?—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to you, you will create your sensationalising book around it and make, no doubt, great deal of money. Who will play my part in the film, Herr Professor McBride?’ The blind man had perceived the ego lurking behind the mask of the bland, sober historian. Probably knew of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I am pursuing only the truth, Herr Menschler.’ It sounded palpably untrue, impossible, pompous. McBride wanted to laugh at himself, but Menschler did it for him, a sharp, barking sound, something long unused. And the truth will make you rich, mm? I believe there is a vogue for such books at the moment. My daughters tell me so. They are very often surprised to discover that my tales to their children are not merely an old man’s dreams. They are products of the Socialist ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("wirtschaftwunder, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of course. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Who was Adolf Hitler? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And so on.’ Menschler waved his arms, dismissing his descendants perhaps for generations to come, but not for ever. McBride felt it was unfair for an ex-Nazi to be so perceptive about ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("his ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("world. Especially unfair in a man blinded by a shell fragment in the Chancellery grounds and who had exiled himself—probably on his state pension—from the post-war Germany.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And they show such a thing as ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Holocaust?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler continued, his face entirely perspective lines towards the blind eyes. He was deeply angry. The hands polished the wooden arms of his chair in deep, massaging movements. ‘The filthy lies—these new Germans accept them, spit on the past as if it had nothing to do with them—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride was appalled. He was losing Menschler.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Very well, Herr Oberst. You wrote from Guernsey in the Channel Islands, from France, and from Belgium to Alfred von Kass during the second half of 1940. What were you doing in the support planning staff after the postponement of ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Seelöwe?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride leaned forward in his chair towards the blind man, urging him to answer, wishing for a loose senility of tongue or an avarice that might take a fee as bribe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I was acting the part—rather well—of a German staff officer, Meinherr; that is what I was doing.’ McBride was incensed by the lordliness of the response, angry that the man was determined to retain secrets to which McBride felt he had some admissible rights of acquisition.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What was Emerald Necklace?’ he almost shouted. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("‘Was ist Fall Smaragdenhalskette?’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He felt hot and angry and blocked in that cold room. The man would ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("see ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("nothing, give nothing away–")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler was smiling with superiority.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It was—nothing at all. As you admit, there are no records, Herr Professor, and no one will tell you. In fact, you will never prove that the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("halskette ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("ever came out of the jeweller’s window.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why in God’s name won’t you talk about it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why—why? Is there a ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("right ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("that you have to know?’ Menschler seemed to know that McBride had risen from his chair and had adjusted his head so that the blind pale eyes still looked into McBride’s face.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Tell me, damn you, tell me!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No. I choose to remain in the conspiracy of silence. My motives are not important, and they would not be understood by someone as—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("crass ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("as you. One of my daughters tried to ask me questions about your book, ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell.’ ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Menschler held up his hands and closed them into claws. ‘I tore the book to pieces, Herr McBride. You have dirty hands, and you will never touch the necklace with them. I ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("choose ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("not to tell you—and there is nothing you can do about that!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The "), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Rt Hon David Guthrie, MP, HM Secretary of State for Northern Ireland, had flown by helicopter from Stormont Castle to Aldergrove airport, then on an RAF flight to Northolt, and been driven into London by a Ministry driver. Now, in the office of "), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Davidge the Home Secretary, preparing for an urgent meeting with the Prime Minister, Guthrie still looked at his ease, and to Davidge, as if he were appearing on television. Moving with the grace of an athlete or an actor, using his profile, marking off the room like his territory as he moved about it or stood looking out over St James’s Park in the autumnal mist that had persisted all morning. Though Davidge knew that the territory he really wished to appropriate was the office where they would lunch with the Premier.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The press considered almost everything Guthrie did and said as a piece of canvassing for some future election, some anticipated occupation of 10 Downing Street—but the press was usually kind, and more than normally impressed by the promised all-party conference, under Guthrie’s chairmanship, to decide the power-sharing future of Ulster. Davidge, as he watched the man he could not be like and could not, therefore, like or admire, sensed the electricity running between the reports on his desk and the man at the window.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The Provisional IRA had detonated five hundred pounds of explosive at Aldershot, and a lot of soldiers and their families were dead and injured. And a second bomb had been defused at Catterick. In the wake of bombs in Birmingham, Leeds, Liverpool and Southampton. Yet Guthrie appeared at ease.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("For Davidge, to whom the same school, the identical university and a parallel political career had not given the same ease before the cameras or the same overriding self-assuredness, Guthrie was habitually an irritant. He was still the man’s fag, after all the years that had passed.  ‘What is the PM’s feeling about the latest mainland bombings?’ Guthrie asked finally, a look of frank distaste souring his features. As if he had spotted a weakness within himself which the words embodied.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Distress—I think one may use the word unreservedly.’ Guthrie turned to face Davidge as he sat at his desk. ‘Two bombs in Dublin, another in Waterford,’ he snapped, as if he were the intended victim. ‘Fires all over Belfast and Derry. Those bastards are worried, Davidge—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("really ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("worried!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But will they succeed, Guthrie—that is what you will be asked this afternoon—can they succeed?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘In wrecking the conference, you mean?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What else? That, I take it, is the object?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I should presume so.’ Guthrie rubbed his chin and stared across the low mist shrouding the park. It looked cold out there; figures moved through the mist as little more than dancing spots tiredness might have brought to his eyes. He’d seen the growing apprehension on the faces of his PPS, and the Parliamentary Under-Secretary. Even the GOC’s staff were apprehensive, and felt unfairly restrained, in a low-profile response which Guthrie hoped might keep the SDLP and the Unionists firmly committed to the Leeds Castle conference.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was within his grasp, was still within it, even though the Provisional Sinn Féin seemed to drink the latest outrages like a cordial and were backing away from the conference table.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Soldiers’ wives, in the last couple of days when he had visited stations in Germany—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("campaigning, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the press had called it, and he would not give them the lie on that—looked doubtful, apprehensive, faces closed to their husbands doing a third or fourth tour of duty in the province. It was all there, spread out like cards on baize or—more clichéd still—his was the final throw of the dice. He believed he could still win.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The middle ground’s still secure,’ he murmured as if to himself. ‘Paisley is holding back, like a virgin at a party, but he’s the spokesman for a tired people. The UVF and the rest of the Protestant lunatic fringe have been alienated, and he knows it. The Protestants are prepared to give—’ He shook his head. ‘All the conditions for success are there, Davidge,’ he turned to the Home Secretary, one hand before him in an upturned fist, ‘which is why the Provisionals are ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("now, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and why it’s their last, desperate effort. Lashing out blindly—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Provisional Sinn Féin haven’t dissociated themselves from the violence—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, they’re more likely to dissociate themselves from the conference, unless you can make arrests.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Special Branch are hopeful—another sprig of the Braintree growth, they think. I shall authorise a number of raids for tomorrow.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You must—’ Guthrie could say no more. Davidge felt uncomfortable under his glance, and distinctly irritated that he was being made to serve Guthrie’s self-seeking. ‘There’s an uncommon closeness of mind between the Provos in the Sinn Féin and the IRA just at the moment. Among the younger, wilder elements, at least. They’re doing what they can south of the border, but the Provos are not coming out of hiding. We have to have ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("these ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("bombers, the ones on the mainland, if we are to maintain credibility. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Everyone ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is so much closer than they were at Sunningdale—we can’t have the cement blown out of the brickwork at this late date!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("November 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was raining, and there was a wind sweeping across Guernsey which spattered the hard drops against one side of his face. The left side, which was now almost dead to any feeling, ached with awakened blood vessels whenever he rubbed it. Minor discomfort. He was far more concerned with the duration of the shower and the time he was wasting keeping to the roadside ditch. It was already after dark, and after curfew.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Yet there was the same elation, familiar rather than self-betraying. They had told him, years ago when Drummond had first recruited him, that a lot of the work was sheer and unadulterated boredom. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("A pain in the backside, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("one senior instructor had drawled, dismissing espionage much as he might have done other people’s boils. Michael McBride—currently Lt Commander McBride, RN—had wondered at the virginal excitements of training, at the persistence of such feelings during early operations immediately prior to the war, and then grown accustomed and accepting. Apparently—he smiled even now as he formed the thought—he was made to be an agent. He had found his ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("métier, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("his vocation.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He climbed out of the muddy ditch, pumping his hands against his arms, flapping himself warm. He took out the pencil torch, flicked on the thin beam for a second, and nodded. He was half a mile outside St Peter Port, on the main road from St Sampson and the cove north of Clos-du­Valle where the submarine had landed him. The S-class submarine could not navigate between Herm and Guernsey in safety—could have brought him no further south and nearer St Peter Port. He was making reasonable time, but he was impatient to arrive in St Peter Port, as a lover would be for a rendezvous.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He could not be certain of the currency of his forged papers, which were designed to get him down to the main harbour itself, certainly through and past the patrols in the town. He had been ordered to go nowhere near any of the contacts among the occupied islanders—Admiralty Operational Intelligence Centre had made that the strictest parameter of his job. He was not to be known to be on Guernsey. Even at the risk of the papers he carried being days, even hours, out of date.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He crossed the coast road, looked down over Belle Greve Bay briefly, taking in the new ugly groins, the barbed wire rolls along the strip of deserted beach, the titled signposts, the empty beach huts falling into disrepair almost in a single glance. He’d been to Guernsey before on minor jobs but none had been like this one, from the tight-lipped briefing and the solemn faces that made him want to smile—but this landscape of fear and occupation was ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("déjà vu ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("simply because it was a scenery natural to him and his unusual occupation. Curtains blacked out the windows and lights of the newish retirement bungalows that straggled out along Les Banques from the old town in an effort to ribbon-develop St Peter Port and St Sampson. Some of them were empty, and some—he moved back across the road as he let in the thought—were used to billet Wehrmacht officers of the forces of occupation. And he must get on—it was strictly a one-night-stand, my darling. He dropped back into the ditch and began moving more quickly along it. It was coming on to rain harder, and he did not worry. He was a passenger, moving too quickly for slow German minds and slower hierarchy of action.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Ten minutes later, he climbed out of the ditch, stood up, and kicked the mud from his boots. At the crossroad ahead, there was a German patrol, and a couple of arc lamps. Pub, tram sheds, bus garage. He could see the street plan of St Peter Port with vivid clarity, almost perceive his own route as a dotted line traced on it—much more clearly than the muzzy aerial pictures that had sent him here. Long low sheds erected in the strongly fortified Albert Marina, intended to conceal as well as protect. Like submarine pens, the briefing officer had observed unnecessarily.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He worked his way behind the pub, where thin edges of light framed the blacked-out windows, paused to listen to the noises of a German song, tossed his head in amusement and in the superiority of moving secretively past, crossed Grand Bouet in a long-striding spring, and ducked down in the shelter of a hedge. Moving through a changed but still somehow pre-war suburbia on a holiday island. The bus garage was patrolled, but minimally.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He kept to the shadows of the buildings, listening with satisfaction to the silence of his passage. He climbed a rickety fence out on to First Tower Lane, took a fenced, grassy lane through to the Rue du Commerce, and re-joined Les Banques, now the esplanade.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Anti-aircraft guns pointed north, sandbagged against the seawall, incongruous opposite the boarding-houses which were mostly now billets. He began to walk openly, hands in pockets, humming softly. Dock worker, curfew permit and ID card in his breast-pocket, walking to join the night shift. He passed the first AA emplacement, and nobody took any notice. Coarse Berliner dance-band music floated occasionally to him on the wind. He skipped in time to it once or twice, because he was enjoying himself and the small part of his personal life which his pregnant wife occupied was dormant for the duration of any job they sent him on.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Along St George’s Esplanade—he recited the names on the pre-war map, aware of the imposed German names, feeling the excitement curling like a drink in his stomach, or a cat contented to be warm and asking no more. The AA emplacement on the Salerie was betraying light, and the smell of cooking. Something with onions. A truck with a canvas hood was parked alongside the sandbags and the hut. Someone laughed, and he heard in a sidestreet a bus cough into life. Workmen’s bus, heading for the harbour, then he was on Glategny Esplanade running along the north beach.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was a barrier and guards at the crossroads. Other workmen by this time, and the checking of papers more perfunctory, as he had expected. He would have been more interesting to the patrol near the pub, coming from outside the town. Now, he was part of the nightly traffic to the harbour, and he joined the little queue of islanders and Frenchmen who had descended from a bus. Inevitably, someone spat in the brave darkness after a guard had passed, machine pistol slung at the ready, boots splashing in the rain. McBride watched the men in front of him, and the manner in which their papers were checked by the officer in the Kreigsmarine greatcoat and the ‘Security’ tabs at collar and armband, and felt an intenser excitement. The guards were from no special unit, but they were alert, bristling with guns and purpose—the kind of charade McBride knew was habitual and which replaced real security when it passed into uneventful routine. The body searches on the way off-shift would be thorough, but he would take nothing away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He came level with the officer, adopted a careless, indifferent silence, and his papers were passed immediately. He had not even considered that they might be spotted as fakes or betray him by an error. Some other part of the organism had shifted him half a yard closer to the nearest soldier, taken in his youth, his build, and the ease with which the machine pistol would come away from his hands. McBride did things for his own survival without caring, with a thorough instinct.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He was waved through the barrier, which swung aside, and kept a couple of steps behind the two men in front of him down the North Esplanade, past the Victoria Marina, then. through another barrier on to the Albert Pier. Here, there were more guards—the tabs of a special security unit clear in the white arc lights, the Kreigsmarine officers more numerous, the check more thorough, longer. He passed through, dismissing the tension that had knotted suddenly in his stomach. The long, low sheds were ahead of him, each one marking a berth or berths. Closed doors, noises from within, lights slitting beneath doors, bursting from cracked windows or torn blackouts. Fuzzy aerial pictures.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He looked around him, slowing his pace so that the men ahead of him increased their distance. The man behind him was catching up. McBride slipped on the wet concrete, cursed in French, and rubbed his ankle under his boot.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hurt?’ the man enquired as he drew level. McBride shook his head, swore and blamed the Germans for the weather, and the man walked on, laughing. McBride looked back at the barrier, lights fuzzy in the rain, and then slipped into the shadow of a warehouse. The sheds were fifty yards from him. He watched as a judas-door opened to admit the men who had been in front of him—the clatter of repair, bright leap of welding sparks, then the door closed. There was an armed guard there, too. McBride rubbed his hands, not entirely to keep warm, and began to wait.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Three in the morning. He")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was stiff with cold, and the single draught of rum had traced a slow, leaky passage like warm snow down his gullet, dissipated and might never have been. He had concealed himself between two of the coal bunkers near the warehouse, at the end of the narrow-gauge track for the steam-crane which unloaded the coal Guernsey still imported for coal-burning coastal vessels. Like switched-off machinery, he had waited. Now, in the tired small hours, it was time to move. The cold was stiffening, annoying, but bearable because it was one of the conditions of the job, like his false papers and the swift row on the incoming rough tide from the slippery deck of the submarine. He was wearing three thick sweaters, long johns, two pairs of trousers—what did he expect?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He stamped his feet, slapped his arms, shuffled and blew, then moved along the wall of the warehouse—once hearing a rat scurry on the other side of the corrugated iron as he paused. The rain was falling almost vertically since the wind had dropped as he carefully emerged on to the pier again. He studied the terrain like an animal, then ran. His boots began what seemed a hideous noise, his breath roared in his ears as if he were unfit and exhausted, then he was in the shadow of the first low shed—a hundred and fifty yards long, he estimated. The noises of repair and service dinned through the corrugated wall as he pressed his cheek against it. Vibration quivered. He paused only for a moment. He had selected the window he wanted and moved swiftly. He had declared his presence—a line of bootprints in the mud from warehouse to shed—to any patrol. They moved around the pier frequently, but he expected laxity this late in the night. He had perhaps fifteen minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He moved along the side of the shed. The windows were high up near the sloping edge of the roof, for ventilation more than light. Pricks of light came from most of them. The ladder was at the seaward end of the shed.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He climbed quickly and silently, up into the wind that had changed its mind and sprung back. The handholds were icily wet. He paused at the top, surveyed the area around him. Guards tended to huddle round fires in huts, but he wanted to be certain. Nothing moving. He eased himself on to the roof, and moved in a waddling crouch along its edge. It took him whole minutes to reach the window he had selected, but he did not slip once, holding his feet as he moved them against the bolts that fixed the roof to the walls, resting his heels in the corrugations. His thighs and the backs of his legs ached when he reached his goal. Here, he tested the roof’s edge, and the guttering, took firm hold with his now unmittened hands, the cold of the iron a shock that ran in a shudder through his system—then lowered his body over the edge of the roof so that he hung against the window, the weight of clothing and boots sudden and painful in his shoulders and arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The tear in the blackout cloth was thin, and long. He shuffled his handhold until he could lean in against the dirty glass, and see—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The submarine being worked on almost directly below him was a bloody mess, there was no doubt about that; only amazement that it had limped back for repairs. Most of the crewmen in the forward section of the hull must have died or been badly torn up. The bow bulged open like a crusted sore, and the deck-plates had been shuffled like untidy cards. McBride estimated that the sub had lost ten or twelve feet of its bow. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Internal explosion? Torpedo? Mine? Depth charge?\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A big U-boat, and another beyond it, being checked over for plate-wear, hull-strain. Two of the biggest class of German U-boat, men hurrying about them. If each shed contained even one, then there was a pack of ten here—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("on Guernsey? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These were submarine pens, but not like La Rochelle, Brest and St Nazaire and the rest of the Normandy and Brittany pens—no concrete, no massive servicing backup, no—")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("permanence—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("? It had taken the Germans no more than a couple of days to throw up the corrugated sheds—which could only be for concealment, then.\t")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("These boats were either ‘milch-cow’ refuelling subs, or they were long-trip, ocean-going boats, designed to bite the jugular where it was exposed, far out in the Atlantic—not around the North Channel where the convoys turned for the Mersey and the Clyde. Why here? For God’s sake, he told himself sternly, as if lecturing the general staff of the Kreigsmarine, it’s like keeping old silver in a pillowcase under the bed. He smiled, shifted to test the weariness of his arms, then continued his surveillance. His hands were beginning to go dead.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The damaged submarine in front of him carried no deck gun. He could not see a single torpedo-trolley, not even the necessary hoists to lower the torpedoes on board. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("They were going out unarmed? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His arms weakened with the shock, he felt as if struck. The mysteriousness of what he had found assailed him like a punch that simply went on happening, almost for a minute. He could find no answer, and his ignorance was like an impotence. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("What else, what else? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("he prompted himself. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Concentrate.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At the stern of the submarine—and the one beyond it—he saw the strange, out-of-place pillars, curved and jointed like insect mandibles. The men working at the bow of the undamaged boat were erecting stanchions, and he assumed that the missing bow-section of the other sub had borne a similar, inexplicable mounting.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was nothing else, nothing he could take in as clearly as before. Fact had been deadened by speculation. He was wasting his time now, it might come back later, just as if he had caught it on film, when he was debriefed. Once the resolve had gone, it was hard to hang on for sufficient time to take in the scene once more, repressing the selectivity of speculation. He wondered whether he could haul himself up with the frozen hands and aching arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("One thing more—his angle of vision had precluded sight of them before, but now they moved nearer the stern of the damaged sub, as if to inspect the mountings. Two senior officers—one wearing a Wehrmacht greatcoat, the other in naval uniform. His weariness, the aching muscles in his arms, seemed to go away to a great distance. He was a spectator of some adult drama he could not comprehend. There was a familiarity, a common cause between the two senior officers, so unlike the Intelligence proclamations of intense and unceasing rivalry between the Wehrmacht and the Kreigsmarine; all the way up to the General Staff and the Fuhrer. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("What in hell were they doing?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Their conversation went on for minutes, then the two men shook hands, there was much self-congratulation, and, as they walked out of his view, he groaned with the return of awareness to his arms and shoulders. He didn’t think he could pull himself back up—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The voice from below him settled the matter. ‘You—drop to the ground, at once!’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride did not look down, nor did he pretend not to understand German.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 1980")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thomas Sean McBride parked the mud-stained Audi in the hotel car park, collected his room key and mail from the stiffly-polite clerk, whose words he brushed off as if they came between him and the indulgence of his weary disappointment, then took the lift to his third-floor room with its view across the Moselstrasse to the river and the suburb of Lutzel on the opposite bank.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When he had closed the door behind him, draped his raincoat over a chair, and slipped off his shoes, he poured whisky from an almost empty bottle into a tooth-mug, and stood at the window looking across the darkening river, occasionally shifting his half-seeing gaze to his right, where the Deutsches Eck promontory marked the confluence of the Moselle and the Rhine. His eyes were gritty with a bad night’s sleep in the ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("gasthaus ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in Norden, after the evening ferry journey back from the island, and aching from the whole day’s driving back to Koblenz. His mind creaked through the grooves of disappointment and frustrated rage the blind Menschler’s words had worn.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A barge passed slowly across his vision towards the confluence of the rivers, from his vantage hardly seeming to move. It possessed an apt, facile symbolism. A woman collected washing at its stern—that didn’t fit the symbolism, and he smiled, sipped again at the whisky, almost shrugged off his mood. The first streetlamps were coming on along the Moselstrasse, and the brake lights of the cars sprang out as red globes as the cars pulled up at traffic signals. Behind him in the unlit room his scattered—now ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("useless, fatuous—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("papers, which he had enjoined the maid not to dust or tidy, and the leaning heaps of reference books subsided into gloom. Even so, his mind could not ignore them; an inward eye focused on them more clearly than his retinae registered the passage of the barge.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("e had had it in the palm of his hand—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("He’d blown it, crapped out on a blind man. The Woodstein of World War Two had gone down without throwing a punch! ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He knew he was easing himself into a better mood—the bitterness was gone from the self-mockery, which might have been an effect of the whisky. Still, a blind man! His innate self-confidence, the blooming ego under the sun of his")]), _c('span', {
    staticClass: "CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("best-selling status, his greater potential, combined to prevent him from long periods of self-condemnation, self­awareness. He no longer had anything to fear from the less­clever men who eased past him into the grandly titled chairs of study or into the plush administrative grades. Menschler, therefore, was not an interview board of one, turning him down; without enemies, real or presumed, McBride was unable to categorise Menschler with them, and thereby retain an anger towards him. He was the dead, keeping the grave’s secrets.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There’d be others.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He turned away from the window, put down his glass on the writing-table, ignored the open notebooks, the last pages of his trace of Menschler through army pension records and the telephone exchange, and fanned out instead the letters he had collected from the desk.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His eye was caught by the smallest notebook, but only momentarily, in which on three neat pages he had summarised his knowledge of Emerald Necklace. Little more than the faintest trace of an old perfume. He picked up the bulkiest letter, feeling through the envelope another, enclosed letter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Gaps in Wehrmacht records, in the Führer Directives, in the papers of the General Staff. And a tight-lipped silence.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He shrugged off a returning investigative mood, and ripped open the outer envelope, from his university and presumably forwarding the other letter. He was seized—perhaps in compensation for disappointment—with a childish mood, with the eagerness of discovering of a child from a home where mail seldom came.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Excitement became self-mockery until he had carried the letter to the window. An airmail letter. And he recognised the handwriting? Yes, strong, small, neat. Gilliatt’s hand. Peter Gilliatt, who had helped his mother out of Ireland in ‘41, and got her to America, had written to her in New Jersey, but whose mail had lost the cold trail after his mother had moved them west, to Oregon. Gilliatt must be an old man by now—")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("McBride savoured not opening the letter, the little childish excitement warm as the drink in his stomach. An old, familiar world was coming back with that handwriting, the red-blue edging of the envelope. The handwriting retained the secret of Gilliatt’s age. He’d found out that McBride was in Portland and written to the faculty; McBride nodded in self-compliment. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell—")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Gilliatt had read it. Had he written about that? After all, his mother had been dead for nearly four years, and he’d never even met Gilliatt.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He’d entertained the fantasy, when the letters used to come to Jersey and his mother never seemed to tire of talking about Gilliatt, that the Englishman was his real father, despite the disparity of name. At first, the fantasy possessed romance—until his accidental consultation of a dictionary for the meaning of the word ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("bastard ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in a book he was reading under the bedclothes with a torch. Then the fantasy had become shameful and secret, and he’d gone back to believing in the fact of Michael McBride, dead and buried in Ireland.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A long preamble, compliments on ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Gates of Hell, ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("references to Michael, an invitation to visit him—and, certain as signposts, the change of tone. The hushed, secretive tone, and the sudden temptation to look over his shoulder communicated to the reader. The wrist adopting a nervous twitch as if to turn the letter’s contents away from eyes that might be watching behind the double-glazing.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("My visitor told me you were in Europe, but not where, hence my writing to you at your university. He seemed inordinately interested in your current field of study, and to smile as if he possessed prior information. He suggested—in a very oblique manner—that your work might have a bearing on the events of 1940 in which your father and I were together involved. I should welcome an opportunity of talking to you on this subject—your mother knew little, and I have no doubt would have told you nothing. I, too, have felt bound by certain security restrictions. Until now. I have been bluntly warned not to help you, without being told why. I am irritated by the presumption of it all!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Therefore, if this reaches you, and you have the time, come to me and we shall go over some very old times together. I doubt you have ever known what happened to your father, and perhaps it is time you did.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was as bald and provoking as the trailer to a mystery film. McBride was amused, intrigued and disturbed in a complex moment of emotion. Instinctively, as soon as he had read the signature he moved. away from the window and laid the letter carefully on the writing-table. Gilliatt had deliberately constructed his story with a novelist’s sense of having to grab his reader. Half a dozen mysteries—were hinted at, and strangers moved at the edges of the page, concealed in shadow. McBride felt himself enmeshed, as it was intended he should be.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The room darkened as he revolved the last paragraphs in his mind and sipped the last of the drink. When the telephone rang, it startled him out of his reverie, but with the shock of cold water, or a threat. He shrugged, smiling away the insidious effect of the letter.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘McBride.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The voice was distant, official, clipped. ‘Herr Professor Thomas McBride?’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, who is that?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The Embassy of the Deutsches Democratisches Republik.’ McBride felt an irrational chill, an aftermath of his daydreaming, then recollected his hoped-for outcome of the call. Yet now he was impatient ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("not ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to go to East Berlin, just as over the past weeks he had pestered the DDR authorities for a ‘scholar’s visa’ for the chance to inspect archives on the other side of the wall. He tried to shake off Gilliatt’s unspecified claims on his time.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes?’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Your permission to visit Berlin to consult certain historical records has been granted, Herr Professor.’ A pause into which McBride should have dropped his gratitude like a silver collection.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Thank you, but I’m afraid I’m very busy right now—’ ")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Herr Professor, the visa and the other papers are valid only for a few days. Besides, the importance of the papers you wish to see—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, I see—’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You wish to refuse this excellent, unique opportunity, Herr McBride?’ There was academic demotion in the mode of address. ‘Herr Professor Goessler of the University, our leading expert on these documents returned to the Democratisches Republik by our Soviet friends—and one of our leading authorities on the Fascist period—’ A slight pause, as if the sentence had escaped him in its own complexity, then: ‘He has agreed to place himself at your disposal.’ It was not an inducement; rather, quiet outrage.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I see—’ Gilliatt’s letter was indecipherable on the table in the darkness of the room. ")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Smaragdenhalskette. ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Who could tell?")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Why in hell should Menschler get the last laugh? ")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It was as if the writing on the pages of the letter were in secret ink, and the warmth applied to its revelation had now gone, and the symbols were disappearing once more. He shrugged.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sure—and thanks. Thanks. I’ll drive up to Bonn tomorrow and collect the papers.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Good. But that is not necessary—they have been put in the post to you today. You may book a flight for tomorrow afternoon. Good hunting, Herr Professor.’")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body- _idGenParaOverride-1",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The official broke the connection. McBride was left with the return of an older and more powerful scent than the fate of a father he had never known. He did not for one moment consider why the East German embassy should be concerned with his unimportant documents at eight in the evening.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b500b26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmeraldDecision4.vue
// module id = 81
// module chunks = 0